export default function MovementAccountSelect({ accounts, cards, value, editing, loading, failed, onChange }) {
  const credit = value.payment_method && value.payment_method !== "cash";
  const selected = credit ? `card:${value.payment_method}` : `account:${value.account_id || "unassigned"}`;
  const active = accounts.filter(account => !account.archived);
  const banks = active.filter(account => account.kind !== "cash");
  const cash = active.filter(account => account.kind === "cash");
  const label = value.type === "income" ? "¿Dónde recibiste el dinero?" : "¿De dónde sale el dinero?";
  const missingAccount = !credit && value.account_id && value.account_id !== "unassigned" && !active.some(account => account.id === value.account_id);
  const missingCard = credit && !cards.some(card => card.id === value.payment_method);
  const closedOrigin = editing && accounts.find(account => account.id === (value.original_account_id || value.account_id) && account.archived);
  const options = list => list.map(item => <option key={item.id} value={`account:${item.id}`}>{item.name} · {item.currency}</option>);

  return <label className="text-sm w-full block">{label}
    <select className="w-full border rounded-xl p-3 bg-white text-slate-800" aria-label={label}
      value={selected} disabled={loading || failed || (editing && credit)}
      onChange={event => {
        const [kind, id] = event.target.value.split(":");
        const source = (kind === "card" ? cards : accounts).find(item => item.id === id);
        onChange({ payment_method: kind === "card" ? id : "cash", account_id: kind === "card" ? "unassigned" : id }, source);
      }}>
      <option value="account:unassigned">Por ubicar · sin cuenta asignada</option>
      {missingAccount && <option value={selected} disabled>{value.account_name || "Cuenta del movimiento"} · no disponible</option>}
      <optgroup label="Cuentas y billeteras">
        {banks.length ? options(banks) : <option disabled>No tienes cuentas registradas</option>}
      </optgroup>
      {((!editing && value.type === "expense") || credit) && <optgroup label="Tarjetas de crédito">
        {cards.map(card => <option key={card.id} value={`card:${card.id}`}>{card.name} · {card.currency}</option>)}
        {missingCard && <option value={selected}>{value.credit_card_name || "Tarjeta del movimiento"}</option>}
        {!cards.length && !credit && <option disabled>No tienes tarjetas registradas</option>}
      </optgroup>}
      <optgroup label="Efectivo">
        {cash.length ? options(cash) : <option disabled>No tienes efectivo registrado</option>}
      </optgroup>
    </select>
    {loading && <span className="text-xs text-slate-500">Cargando cuentas y tarjetas…</span>}
    {failed && <span role="alert">No se pudieron cargar las cuentas y tarjetas. Vuelve a abrir el formulario.</span>}
    {closedOrigin && <span role="alert">La cuenta de origen «{closedOrigin.name}» está cerrada. Antes de guardar cambios, <a href="/dashboard/credit-cards">restáurala en Cuentas y efectivo → Cuentas cerradas</a>. Su historial y los saldos del cierre se conservan.</span>}
    {!loading && !failed && !active.length && !cards.length && <span className="text-xs text-slate-500">Puedes agregar cuentas y efectivo en Cuentas y tarjetas, o dejar este movimiento por ubicar.</span>}
  </label>;
}
